import { SET_SAMPLE_GROUP_DETAIL } from "../mutation.type";
import Vue from "vue";

const state = {
  sampleGroupDetail: null,
};

const mutations = {
  [SET_SAMPLE_GROUP_DETAIL]: (state, detail) => {
    Vue.set(state, "sampleGroupDetail", detail);
  },
};

export default {
  state,
  mutations,
};
